export default (pgbaDate) => {
    let display = '';
    if (pgbaDate && pgbaDate.date && (typeof(pgbaDate.date) === 'string')) {
        const dateParts = pgbaDate.date.split('-');
        if (dateParts.length == 3) {
            display = `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
        }
    }
    return display;
};
